export const CONSTANTS = {
  BATTERY_HEADER:
    "Select a Battery from the dropdown list or Customize a new Battery and add it to your User account",
  BATTERY_CONFIGURATION: "Parameters Configuration",
  INVEST_OPERATE_CHARGES: "Investment Details",
};

export const grayIconStyle = {
  backgroundColor:
    localStorage.getItem("mantine-color-scheme") === "dark"
      ? "transparent"
      : " #f5f5f5",
  padding: "4px",
};

export const focusInput = (index, inputRefs) => {
  if (inputRefs.current[index]) {
    inputRefs.current[index].focus();
  }
};

export const handleAssetInfo = (renderFunction, assetDetails, setAssetInfo) => {
  let allManufacturerListNew = [];
  let manufacturerListAll = {};
  if (renderFunction.renderAssetDetails) {
    assetDetails.assetsType.forEach(
      (assetTypeData) => (manufacturerListAll[assetTypeData.type] = [])
    );
    assetDetails.assets.forEach((asset) => {
      if (manufacturerListAll[asset.type.type]) {
        manufacturerListAll[asset.type.type].push(asset.manufacturer);
        manufacturerListAll[asset.type.type].sort();
      }

      if (!allManufacturerListNew.includes(asset.manufacturer)) {
        allManufacturerListNew = [
          ...allManufacturerListNew,
          asset.manufacturer,
        ];
      }
    });
    setAssetInfo((prevState) => ({
      ...prevState,
      allManufacturerList: allManufacturerListNew.sort(),
      manufacturerList: manufacturerListAll,
    }));
  }
};

export const handleAssetValues = (
  setAssetDetails,
  setAddStatus,
  setIsLoading,
  setPopupStatus
) => {
  setAssetDetails((prevState) => ({
    ...prevState,
    assetAttributes: [],
  }));
  setAddStatus(false);
  setIsLoading(false);
  setPopupStatus((prevState) => ({
    ...prevState,
    addAssetPopupStatus: false,
  }));
};

export const handleFilteredAsset = (res, setBatteryList) => {
  const assetList = res?.assetCatalogue?.[0]?.assetList || [];
  let filteredAsset = [];
  try {
    const userScope = JSON.parse(localStorage.getItem('scope'));
    if (userScope && userScope.access && userScope.access.saveUpdateComponent) {
      filteredAsset = [
        { value: 0, label: "Custom" },
        ...assetList.map((a) => ({
          label: a.manufacturer + " " + a.communicationModel,
          value: a.assetId,
        })),
      ];
    } else {
      filteredAsset = assetList.map((a) => ({
        label: a.manufacturer + " " + a.communicationModel,
        value: a.assetId,
      }));
    }
  } catch {
    filteredAsset = assetList.map((a) => ({
      label: a.manufacturer + " " + a.communicationModel,
      value: a.assetId,
    }));
  }
  setBatteryList(filteredAsset);
};

export const handleAddUpdateDataToAssetList = (
  data,
  status,
  assetDetails,
  setAssetDetails
) => {
  if (status) {
    let newAssetList = [...assetDetails.assetsData];
    newAssetList.push(data);
    setAssetDetails((prevState) => ({
      ...prevState,
      assets: newAssetList,
      assetsData: newAssetList,
    }));
  } else {
    let assetIndex = 0;
    let newAssetList = [...assetDetails.assetsData];
    newAssetList.forEach((assetData, index) => {
      if (assetData.assetId === data.assetId) {
        assetIndex = index;
      }
    });
    if (assetIndex) {
      newAssetList[assetIndex] = data;
    }
    setAssetDetails((prevState) => ({
      ...prevState,
      assets: newAssetList,
      assetsData: newAssetList,
    }));
  }
};

export const handleProjectComponents = (
  projectComponents,
  batteryListData,
  setProjectComponents,
  batteryValue,
  setValues
) => {
  if (
    !batteryValue ||
    batteryListData?.length === 0
  )
    return;
  const selectedBatteryId =
    batteryValue ||
    projectComponents?.battery?.uiAttributes?.batteryParameters?.selectBattery;
  if (!selectedBatteryId) return;
  const matchedAsset = batteryListData.find(
    (asset) => asset.assetId === selectedBatteryId
  );
  if (!matchedAsset) return;
  const assetAttributes = matchedAsset.assetAttributes || [];
  const getAttributeValue = (type, defaultValue = null) => {
    const attr = assetAttributes.find((attr) => attr.type === type);
    return attr ? attr.value : "";
  };
  const updatedBatteryState = {
    ...projectComponents,
    battery: {
      ...projectComponents.battery,
      componentAttributes: {
        ...projectComponents.battery.componentAttributes,
        batteryParameters: {
          ...projectComponents.battery.componentAttributes.batteryParameters,
          EfficiencyDischarge: getAttributeValue("EfficiencyDischarge")||projectComponents?.battery?.componentAttributes?.batteryParameters?.EfficiencyDischarge,
          EfficiencyCharge: getAttributeValue("EfficiencyCharge")||projectComponents?.battery?.componentAttributes?.batteryParameters?.EfficiencyCharge,
          PowElecNominalCharge: getAttributeValue("PowElecNominalCharge")||projectComponents?.battery?.componentAttributes?.batteryParameters?.PowElecNominalCharge,
          PowElecNominalDischarge: getAttributeValue("PowElecNominalDischarge")||projectComponents?.battery?.componentAttributes?.batteryParameters?.PowElecNominalDischarge,
          SOCMax: getAttributeValue("SOCMax")||projectComponents?.battery?.componentAttributes?.batteryParameters?.SOCMax,
          SOCMin: getAttributeValue("SOCMin")||projectComponents?.battery?.componentAttributes?.batteryParameters?.SOCMin,
          CapaMax: getAttributeValue("CapaMax")||projectComponents?.battery?.componentAttributes?.batteryParameters?.CapaMax,
          DegradationFactor: getAttributeValue("DegradationFactor")||projectComponents?.battery?.componentAttributes?.batteryParameters?.DegradationFactor,
          MaximumCharge: getAttributeValue("MaximumCharge")||projectComponents?.battery?.componentAttributes?.batteryParameters?.MaximumCharge,
        },
      },
      uiAttributes: {
        ...projectComponents.battery.uiAttributes,
        batteryParameters: {
          ...projectComponents.battery.uiAttributes.batteryParameters,
          lifetimeInYears: getAttributeValue("lifetimeInYears")||projectComponents?.battery?.uiAttributes?.batteryParameters?.lifetimeInYears,
          setupControlParameter:
            getAttributeValue("SOCMax") !== "" ||
            getAttributeValue("SOCMin") !== ""
              ? true
              : false,
        },
      },
      economicAttributes: {
        ...projectComponents.battery.economicAttributes,
        batteryParameters: {
          ...projectComponents.battery.economicAttributes.batteryParameters,
          LifetimeCycle: getAttributeValue("LifetimeCycle")||projectComponents?.battery?.economicAttributes?.batteryParameters?.LifetimeCycle,
          CAPEX: getAttributeValue("CAPEX")||projectComponents?.battery?.economicAttributes?.batteryParameters?.CAPEX,
          OM: getAttributeValue("OM")||projectComponents?.battery?.economicAttributes?.batteryParameters?.OM,
          Replacement: getAttributeValue("Replacement")||projectComponents?.battery?.economicAttributes?.batteryParameters?.Replacement,
        },
      },
    },
  };
  setProjectComponents((prev) => {
    if (
      JSON.stringify(prev.battery) !==
      JSON.stringify(updatedBatteryState.battery)
    ) {
      setValues(updatedBatteryState?.battery);
      return updatedBatteryState;
    }
    setValues(prev?.battery);
    return prev;
  });
  
};
